import { render, staticRenderFns } from "./DistributionByType.vue?vue&type=template&id=64619056&scoped=true&"
import script from "./DistributionByType.vue?vue&type=script&lang=js&"
export * from "./DistributionByType.vue?vue&type=script&lang=js&"
import style0 from "./DistributionByType.vue?vue&type=style&index=0&id=64619056&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64619056",
  null
  
)

export default component.exports